import React from 'react';
import { Container, Column, VerticalSeparator, StyledLabel } from './Styles';

const ColumnsLayout = ({
  header,
  subheading,
  columns,
  disclaimer,
  filterBar,
  footer
}) => {
  const numberOfColumns = columns.length;
  return (
    <>
      <div>{header}</div>
      <StyledLabel testId="page-header-caption">{subheading}</StyledLabel>
      {disclaimer}
      <div>{filterBar}</div>
      <Container>
        {columns &&
          columns.map((column, i) => {
            const key = `column-${i}`;

            return (
              <React.Fragment key={key}>
                {i > 0 && <VerticalSeparator />}
                <Column numberOfColumns={numberOfColumns}>{column}</Column>
              </React.Fragment>
            );
          })}
      </Container>
      <div>{footer}</div>
    </>
  );
};

export default ColumnsLayout;
